import React from 'react';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { paginationDropdownOptions } from 'utils/utils';

export default function getListViewPaginationTemplate({
  pageLimit,
  onPageChange,
  nextChange,
  previousChange,
  paginationToken,
  previousToken,
  files,
}) {
  return {
    layout: 'RowsPerPageDropdown PrevPageLink NextPageLink',
    RowsPerPageDropdown: () => (
      <React.Fragment>
        <span className="mx-1" style={{ color: 'var(--black-500)', userSelect: 'none' }}>
          Items Per Page
        </span>
        <Dropdown value={pageLimit} options={paginationDropdownOptions} onChange={onPageChange} disabled={files?.length === 0} />
      </React.Fragment>
    ),
    NextPageLink: ({ iconClassName }) => (
      <Button
        onClick={nextChange}
        disabled={!paginationToken}
        className="p-paginator-next p-paginator-element p-link"
        icon={iconClassName}
      />
    ),
    PrevPageLink: ({ iconClassName }) => (
      <Button
        onClick={previousChange}
        disabled={!previousToken}
        className="p-paginator-prev p-paginator-element p-link"
        icon={iconClassName}
      />
    ),
  };
}
